import { render, staticRenderFns } from "./IngresarSiniestro.vue?vue&type=template&id=aa8cd7d8&"
import script from "./IngresarSiniestro.vue?vue&type=script&lang=js&"
export * from "./IngresarSiniestro.vue?vue&type=script&lang=js&"
import style0 from "./IngresarSiniestro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports